import React, { useState, useRef, useEffect } from 'react';
import { Users, ChevronDown } from 'lucide-react';

const PassengerSelect = ({ value, onChange, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const getPassengerText = (num) => {
    if (t.passengers === t.passengers_plural) {
      // Для английского языка
      return `${num} ${num === 1 ? t.passengers : t.passengers_plural}`;
    } else {
      // Для русского языка
      if (num === 1) {
        return `${num} ${t.passengers}`;
      } else {
        return `${num} ${t.passengers_plural}`;
      }
    }
  };

  // Закрытие дропдауна при клике вне его
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="flex flex-grow relative w-full" ref={dropdownRef}>
      <div 
        className="flex items-center justify-between w-full cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center">
          <Users className="text-gray-400 mr-3" size={20} />
          <div className="flex-grow">
            <div className="text-xs text-gray-500 font-medium">{t.passengerCount || 'Пассажиры'}</div>
            <div className="font-medium">{getPassengerText(value)}</div>
          </div>
        </div>
        <ChevronDown className="text-gray-400" size={18} />
      </div>

      {/* Дропдаун для выбора количества пассажиров */}
      {isOpen && (
        <div className="absolute top-full left-0 right-0 bg-white shadow-lg border border-gray-200 rounded-md mt-1 z-30">
          {[1, 2, 3, 4, 5].map(num => (
            <div 
              key={num}
              className={`px-4 py-2 cursor-pointer hover:bg-gray-100 flex items-center ${num === value ? 'bg-gray-50' : ''}`}
              onClick={() => {
                onChange(num);
                setIsOpen(false);
              }}
            >
              <Users className={`mr-2 ${num === value ? 'text-[#9a55f4]' : 'text-gray-400'}`} size={16} />
              <span className={num === value ? 'font-medium text-[#9a55f4]' : ''}>{getPassengerText(num)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PassengerSelect;